// export 文を使って関数 greet1 を定義
export const linkSlider = () => {
  $(function () {
    const linkSlider = $(".js-toplink-slider");
    const linkArrow = $(".js-toplink-arrow");

    linkSlider.slick({
      arrows: true,
      appendArrows: $(linkArrow),
      prevArrow: '<div class="prev-arrow"></div>',
      nextArrow: '<div class="next-arrow"></div>',
      autoplaySpeed: 3000,
      autoplay: true,
      slidesToShow: 3,
      speed: 1000,
      responsive: [
        {
          breakpoint: 768, // SP時のブレイクポイント
          settings: {
            centerMode: true,
            slidesToShow: 1, // SP時は1つ表示
          },
        },
      ],
    });
  });
};
